import { colors } from "../../Styles";

export function Start({size = "20px", fillColor = colors.greyLightTertiary}) {
  return (
    <svg height={size} width={size} fill={fillColor} xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 283.46 283.46">
      <path d="M199.84,131.77C186.06,123.71 124.45,84.41 120.51,81.88C109.58,74.87 100.17,78.93 100.17,89.68L100.17,197.15C100.17,204.46 111.97,208.29 120.86,202.63C136.26,192.82 196.06,154.44 199.84,151.48C203.73,148.43 213.62,139.84 199.84,131.78L199.84,131.77Z"/>
      <g transform="matrix(0.867865,0,0,0.867865,18.5075,18.6225)">
          <path d="M141.73,9.29C68.71,9.29 9.29,68.71 9.29,141.73C9.29,214.75 68.7,274.17 141.73,274.17C214.76,274.17 274.17,214.76 274.17,141.73C274.17,68.7 214.76,9.29 141.73,9.29ZM141.73,252.789C83.03,252.789 31.823,200.43 31.823,141.73C31.823,83.03 83.03,30.671 141.73,30.671C200.43,30.671 252.789,83.163 252.789,141.863C252.789,200.563 200.43,252.789 141.73,252.789Z"/>
      </g>
    </svg>
  );
}